/*
 *
 * Le script De création de barre de cookies
 * Sans .css tout directement créer par le .js
 * 
 * Utilisation de Jquery (même en old version)
 */


$(function() {

  /*
   * Tableau des langues
   */

  var languageV2 = {
    "lang_fr" : {
    	titre : "Course Eiffage",
      message : "utilise des cookies pour vous offrir le meilleur service possible. En continuant votre navigation, vous en acceptez l'utilisation",
      readMore : "en savoir plus",
      lien : "http://www.cnil.fr/vos-obligations/sites-web-cookies-et-autres-traceurs/que-dit-la-loi/"
    },
    "lang_en" : {
    	titre : "Course Eiffage",
      message : "uses cookies to offer you the best possible service. By continuing browsing, you accept the use ",
      readMore : "read more",
      lien : "http://www.cnil.fr/vos-obligations/sites-web-cookies-et-autres-traceurs/que-dit-la-loi/"
    },
    "lang_es" : {
    	titre : "Course Eiffage",
      message : "uses cookies to offer you the best possible service. By continuing browsing, you accept the use ",
      readMore : "read more",
      lien : "http://www.cnil.fr/vos-obligations/sites-web-cookies-et-autres-traceurs/que-dit-la-loi/"
    },
    "lang_de" : {
    	titre : "Course Eiffage",
      message : "uses cookies to offer you the best possible service. By continuing browsing, you accept the use ",
      readMore : "read more",
      lien : "http://www.cnil.fr/vos-obligations/sites-web-cookies-et-autres-traceurs/que-dit-la-loi/"
    },
    "lang_it" : {
    	titre : "Course Eiffage",
      message : "uses cookies to offer you the best possible service. By continuing browsing, you accept the use ",
      readMore : "read more",
      lien : "http://www.cnil.fr/vos-obligations/sites-web-cookies-et-autres-traceurs/que-dit-la-loi/"
    },
    "lang_nl"  : {
    	titre : "Course Eiffage",
      message : "uses cookies to offer you the best possible service. By continuing browsing, you accept the use ",
      readMore : "read more",
      lien : "http://www.cnil.fr/vos-obligations/sites-web-cookies-et-autres-traceurs/que-dit-la-loi/"
    },
    "lang_pl"  : {
    	titre : "Course Eiffage",
      message : "uses cookies to offer you the best possible service. By continuing browsing, you accept the use ",
      readMore : "read more",
      lien : "http://www.cnil.fr/vos-obligations/sites-web-cookies-et-autres-traceurs/que-dit-la-loi/"
    },
    "lang_br"  : {
    	titre : "Course Eiffage",
      message : "uses cookies to offer you the best possible service. By continuing browsing, you accept the use ",
      readMore : "read more",
      lien : "http://www.cnil.fr/vos-obligations/sites-web-cookies-et-autres-traceurs/que-dit-la-loi/"
    }
  };


  /*
   * Function de lectuer de lang sur le body avec sa class
   * En prennent en compte que la premiere class du body et la lang formaté comme dans le tableau si dessus
   */
  function recoveredLang() {
    var chaine = $('body').attr('class');
    var reg = new RegExp("[ ,;]+", "g");

    //console.log(chaine)
    //var tab = $(chaine).value.split(reg);

    return chaine;
  }

  /*
   * Function de creation du cookie
   */
  function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
  }

  /*
   * Function de lecture du cookie
   */
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  function showCookiesWarning() {

    var lang = 'lang_fr';
    /*
     *
     */
    var mess = languageV2[lang].message;
    var more = languageV2[lang].readMore;
    var titre = languageV2[lang].titre;
    var lien = languageV2[lang].lien;
    if (!mess) {
    	mess = languageV2["lang_en"].message;
    	more = languageV2["lang_en"].readMore;
    	titre = languageV2[lang].titre;
    };

    /*
     * Creation de la <div> content le message
     */
    var parts = [];
    parts.push('<div class="cookies-bar" style="position: fixed;bottom: 0; left: 0; width: 100%; min-height: 30px; padding-top: 5px; line-height: 20px; text-align: center;z-index: 5000; background-color: #161616;color: #ffffff; font-size: 13px;');
    parts.push('<div style=" background: black; box-shadow: 0 0 8px black; color: #fff; cursor: pointer; font-family: Arial, Helvetica; left: 0; margin: 0 auto; padding: 10px; position: relative; text-align: center; text-shadow: 0 0 5px black; top: 0; z-index: 1510; font-size: 14px;"');
    
    parts.push('<span class="cookies-bar--span" style=" color: #ffffff;">'+titre+' '+ mess +', </span>' );
    parts.push('<a style=" color: #fff;" href="'+lien+'" target="_blank" class="cookies-bar--more">'+more+'</a><button style="  font-family: Arial, Helvetica; text-align: center; margin: 0 0 0 10px; background-color: #fff; color: #2a2d31; border: 1px solid #fff; font-weight: bold; font-size: 14px; line-height: 14px;" id="cookieLawAccept">ok</button>');
    
    parts.push('</div>');
    parts.push('</div>');

    $('body').prepend(parts.join(''));


    /*
     * Suppression de la barre au click sur le ok
     */

    $('#cookieLawAccept').click(function() {
      createCookie("cookiesWarning",true,390);
      $('.cookies-bar').remove();
    });
  }

  /*
   * Lecture du cookies "cookiesWraning"
   */
  var brownie = readCookie('cookiesWarning');
  if(brownie === null) {
    showCookiesWarning();
  }
});